import { Util } from "/global/js/util.min.js?v=1743070040";
import { t } from "/global/js/translations.min.js?v=1743070040";
import SeasonTickets from "/content/plugins/shop/js/seasonTickets.min.js?v=1743070022";
const util = new Util();
export default class ProductHandler {
  constructor() {
    (async () => {
      this.t = await t;
      this.goToCartModalElem = document.createElement('div');
      this.goToCartModalElem.classList.add('modal', 'fade');
      this.goToCartModalElem.id = 'goToCartModal';
      this.goToCartModalElem.innerHTML = this.goToCartModalHtml();
      this.goToCartModalAppended = false;
      this.showQuantityCustomerModal = false;
      this.goToCartModal = new bootstrap.Modal(this.goToCartModalElem);
      this.modalElem = document.querySelector('#modal');
      this.modal = new bootstrap.Modal(this.modalElem);

      //Bind events
      pubsub.on('addedToCart', data => this.onAddedToCart(data[1]));
      pubsub.on('SeasonTicketsSubmitted', response => this.onSeasonTicketsSubmitted(response));
      pubsub.on('seasonTicketRemoved', count => this.onSeasonTicketRemoved(count));
      pubsub.on('seasonTicketsModuleClose', () => this.seasonTicketsModuleClose());
    })();
  }
  async onAddedToCart(data) {
    const currentUrl = document.location.pathname.split("/");
    if (data.productHaveAdditional.quantityCustomer) {
      this.showQuantityCustomerModal = true;
    }

    //If seasonTicket added
    if (parseInt(data.addedProductAttributes.prodTypeId) === 3) {
      const modal = document.querySelector('#modal .content');
      const htmlMsg = `
                <div class="modal-header border-0 pb-3">
                    <div>
                        <h5 class="modal-title">${data.addedProductAttributes.prodNameCustomer}</h5>
                        ${this.t.__('Please fill out the required information below')}
                    </div>
                    
                    <button type="button" class="btn-close closeBtn" aria-label="Close"></button>
                </div>
                <div class="modal-body border-bottom border-top">
                    <div class="row g-3">
                        <div class="col-md-8">
                            <strong>${this.t.__("Important regarding image upload")}</strong><br>
                            - ${this.t.__("Image must be uploaded")}<br>
                            - ${this.t.__("Image must face correctly")}. ${this.t.__("Use")} <i class="fa-light fa-undo"></i> ${this.t.__("and")} <i class="fa-light fa-redo"></i> ${this.t.__("to turn the image")}<br>
                            <br>
                            <strong>${this.t.__("Guide")}</strong><br>
                            ${this.t.__("Click on Select an image")}. ${this.t.__("Zoom using the slider, move and rotate")} (<i class="fa-light fa-undo"></i> ${this.t.__("and")} <i class="fa-light fa-redo"></i>) ${this.t.__("until your face is clearly and centred")}.
                        </div>
                        <div class="col-md-4">
                            <strong>${this.t.__("REQUIREMENTS for the image")}</strong><br>
                            - ${this.t.__("The person should be in the middle")}<br>
                            - ${this.t.__("The image must be a close-up")}<br>
                            - ${this.t.__("The image must face correctly")} (${this.t.__("Use")} <i class="fa-light fa-undo"></i> ${this.t.__("and")} <i class="fa-light fa-redo"></i>)<br>
                            - ${this.t.__("The face must be clearly visible")}<br>
                            - ${this.t.__("The image type must be JPG")}<br>
                            <br>
                            ${this.t.__("Failure to do so may result in rejection")}.
                        </div>
                    </div>
                </div>
            `;
      const seasonTickets = new SeasonTickets(0, modal, htmlMsg);
      const productId = data.addedProductAttributes.prodId.toString();
      seasonTickets.render([productId + '-0-0-0'], true);

      //Open the modal
      this.modal.show();
    } else {
      if (this.showQuantityCustomerModal) {
        this.quantityCustomerModal();
        return;
      }
      if (!this.goToCartModalAppended) {
        document.body.appendChild(this.goToCartModalElem);
        this.goToCartModalAppended = true;
      }
      this.goToCartModal.show();
    }
    if (data?.infoMsg) {
      pubsub.trigger('info', {
        toast: true,
        infoMsg: data.infoMsg
      });
    }
  }
  goToCartModalHtml() {
    return `
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header pb-0 border-0">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3 mb-5">
                            <div class="col-12 text-center">
                                <i class="fad fa-shopping-cart fa-10x"></i>
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-12 col-md mb-3">
                                <button class="btn btn-secondary w-100" data-bs-dismiss="modal">${this.t.__("Continue shopping")}</button>
                            </div>
                            <div class="col-12 col-md mb-3">
                                <a href="/${this.t.langCode + this.t.pwaUrl}/cart" class="btn btn-primary w-100">${this.t.__('Go to cart')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
  }
  onSeasonTicketsSubmitted(response) {
    const btn = response[1];
    this.modal.hide();
    if (this.showQuantityCustomerModal) {
      this.quantityCustomerModal();
      return;
    }
    if (util.hasClass(btn, 'saveAndGoToCartBtn')) {
      window.location = '/' + response[0].langCode + this.t.pwaUrl + '/cart';
    }
  }
  onSeasonTicketRemoved(count) {
    if (count <= 0) {
      this.modal.hide();
    }
  }
  seasonTicketsModuleClose() {
    this.modal.hide();
    if (this.showQuantityCustomerModal) {
      this.quantityCustomerModal();
    }
  }
  quantityCustomerModal() {
    const productAdditionalCustomer = document.querySelector('#productAdditionalCustomer');
    if (productAdditionalCustomer) {
      this.productQuantityMatchModal = new bootstrap.Modal(productAdditionalCustomer);
      this.productQuantityMatchModal.show();
    }
  }
}